import React from 'react';
import Component from '@vfuk/core-horizontal-bar-chart';
const HorizontalBarChart = props => {
    return React.createElement(Component, Object.assign({}, props));
};
export default HorizontalBarChart;
